<template>
  <div class="switch-container">
    <div class="switch-label">{{title}}</div>
    <label class="switch">
      <input
        type="checkbox"
        :disabled="disabled"
        :checked="checked"
        @click="$emit('update:checked', $event.target.checked)"
      >
      <span class="slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    title: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';

.switch-container {
  @include flex(row, space-between, center);
    padding: 0 3px;
    margin-bottom: 8px;

  .switch-label {
    font-size: 13px;
    margin-right: 12px;
  }
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;
  border: 0;

  input {
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
    outline: 0;

    &:checked + .slider {
      background-color: $gd-blue;
    }

    &:checked + .slider:before {
       -webkit-transform: translateX(16px);
       -ms-transform: translateX(16px);
       transform: translateX(16px);
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: none;
    border-radius: 34px;
    background-color: $secondary-shadow;
    -webkit-transition: .4s;
    transition: .4s;

    &:focus {
       outline: 0;
    }
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    border-radius: 50%;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
}

form.disabled {

  .switch input {
    pointer-events: none;
    background-color: transparent;

    &:checked + .slider {
      background-color: $gd-gray;
    }
  }

  .slider {
    background-color: $gd-gray;
    cursor: default;
  }

  .switch-label {
    color: $gd-gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-elements/ToggleSwitch.vue